export const validateUsername = (username: string) => {
    if (username.includes(" ")) {
        return "Username Cannot Contain a Space"
    } else if (/^[a-zA-Z]+$/.test(username)) {
        return ""
    }
    return "Username can only contain letters of the alphabet";
}